import i18n from 'src/locales/i18n';

// Mesma nota de i18n do catalog.js: dados de módulo, consumidos fora de
// componentes React, então usam a instância singleton do i18next.
const t = (key, defaultValue) => i18n.t(`settings:aiAgents.ecommerce.categorias.${key}`, defaultValue);

/**
 * Lista de fallback do seletor "Adicionar categoria".
 *
 * O caminho normal é carregar as categorias REAIS do cliente
 * (GET /api/v2/categories?ownerId=), porque elas já são um cadastro do tenant —
 * diferente do imobiliário, cuja lista de tipos de imóvel é estática. Esta
 * lista só entra em cena quando a chamada falha ou o cliente ainda não cadastrou
 * nenhuma categoria, para o canvas não ficar inutilizável.
 */
export const CATEGORIAS_FALLBACK = [
    { id: 'roupas', label: t('roupas', 'Roupas'), icon: 'mdi:tshirt-crew-outline' },
    { id: 'calcados', label: t('calcados', 'Calçados'), icon: 'mdi:shoe-sneaker' },
    { id: 'acessorios', label: t('acessorios', 'Acessórios'), icon: 'mdi:bag-personal-outline' },
    { id: 'eletronicos', label: t('eletronicos', 'Eletrônicos'), icon: 'mdi:cellphone' },
    { id: 'casa', label: t('casa', 'Casa e decoração'), icon: 'mdi:home-outline' },
    { id: 'beleza', label: t('beleza', 'Beleza e cuidados'), icon: 'mdi:lipstick' },
    { id: 'alimentos', label: t('alimentos', 'Alimentos e bebidas'), icon: 'mdi:food-apple-outline' },
    { id: 'esporte', label: t('esporte', 'Esporte e lazer'), icon: 'mdi:soccer' },
    { id: 'outros', label: t('outros', 'Outros'), icon: 'mdi:dots-horizontal' },
];

/**
 * Estrutura inicial do fluxo de coleta do varejo.
 *
 * Reaproveita deliberadamente os mesmos `type` de nó do canvas compartilhado
 * (`rootNode`, `finalidadeNode`, `destinoNode`, `tipoNode`), porque a FORMA do
 * grafo é a mesma do imobiliário — raiz, uma bifurcação principal, dois ramos e
 * folhas configuráveis. Só os rótulos mudam. Isso evita parametrizar o
 * `nodeTypes` e o `PROTECTED_TYPES` do canvas, que é a parte mais delicada dele.
 *
 * Aqui os ramos nascem SEM folhas: as categorias reais variam por loja e o
 * lojista as adiciona pelo seletor, em vez de herdar um chute nosso.
 */
export function buildInitialWorkflow() {
    const root = {
        id: 'root',
        type: 'rootNode',
        position: { x: 0, y: 0 },
        data: { label: t('workflowRootLabel', 'Início da coleta'), perguntas: [] },
    };

    const intencao = {
        id: 'finalidade',
        type: 'finalidadeNode',
        position: { x: 0, y: 150 },
        data: {
            label: t('workflowIntencaoLabel', 'Comprar / Pós-venda'),
            icon: 'mdi:help-circle-outline',
            finalidade: 'ambos',
            perguntas: [],
        },
    };

    const ramos = [
        {
            id: 'comprar',
            destino: 'comprar',
            x: -260,
            label: t('workflowRamoComprarLabel', 'Quer comprar'),
            icon: 'mdi:cart-outline',
        },
        {
            id: 'pos-venda',
            destino: 'pos-venda',
            x: 260,
            label: t('workflowRamoPosVendaLabel', 'Já é cliente'),
            icon: 'mdi:truck-delivery-outline',
        },
    ];

    const ramoNodes = ramos.map((r) => ({
        id: r.id,
        type: 'destinoNode',
        position: { x: r.x, y: 310 },
        data: {
            label: r.label,
            icon: r.icon,
            destino: r.destino,
            perguntas: [],
        },
    }));

    const nodes = [root, intencao, ...ramoNodes];

    const edges = [
        { id: 'e_root_finalidade', source: 'root', target: 'finalidade' },
        ...ramos.map((r) => ({ id: `e_finalidade_${r.id}`, source: 'finalidade', target: r.id })),
    ];

    return { nodes, edges };
}
